import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {Link} from "react-router-dom";

export default function VpnAndSubnetArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="text-box text-box--gray">
                        <p>
                            Her kan du læse lidt om, hvad VPN og subnet er, samt hvordan du kan bruge VPN.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad er VPN?</h2>
                        <p>
                            VPN (Virtual Private Network) bruges til at kryptere din internettrafik og skjule din <Link to={'/hjaelp/internet-og-wifi/ip-adresse'}>offentlige IP-adresse</Link> ved at erstatte den med en IP-adresse fra VPN-serveren.
                            Det giver dig mulighed for at tilgå ressourcer på f.eks. et arbejdsnetværk hjemmefra.
                        </p>
                        <p>
                            Det kan også være nyttigt at bruge VPN på offentlige wifi-netværk, som ofte er usikrede.
                            En VPN beskytter dine data ved at kryptere din forbindelse, hvilket reducerer risikoen for, at dine data bliver opsnappet eller kompromitteret.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad er VPN på iPhone?</h2>
                        <p>
                            iOS-enheder understøtter VPN-konfigurationer, men du skal have adgang til en VPN-server fra f.eks. dit arbejde eller en uddannelsesinstitution.
                            Alternativt kan du vælge en tredjepartsapp fra en VPN-udbyder.
                        </p>
                        <p>
                            En VPN kan være en god idé på din iPhone, hvis du rejser til lande med restriktioner eller censur.
                            Hvis du bruger en VPN-server placeret i Danmark, kan du få adgang til de samme websites og tjenester, som du normalt ville have hjemme.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvordan får jeg en VPN?</h2>
                        <p>
                            Vi tilbyder ikke en VPN-service, men du kan frit bruge en VPN sammen med vores internetforbindelser.
                        </p>
                        <p>
                            Hvis du ønsker en privat VPN, kan du finde en udbyder online.
                            De fleste pålidelige VPN-tjenester kræver betaling, men de tilbyder typisk højere sikkerhed og bedre hastighed end gratis alternativer.
                        </p>
                        <p>
                            Populære VPN-udbydere inkluderer NordVPN, ExpressVPN og Surfshark.
                            Undersøg, hvad der passer bedst til dine behov, og vælg en løsning, der balancerer pris, sikkerhed og brugervenlighed.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad er et subnet?</h2>
                        <p>
                            Et subnet er en del af et større netværk.
                            Enheder i samme subnet kan ofte kommunikere direkte, forudsat at de ikke er adskilt af en router eller firewall.
                            Subnets bruges til at organisere netværk og reducere unødvendig netværkstrafik, hvilket gør internet-netværk mere effektive.
                        </p>
                        <p>
                            Når du opsætter din egen router, bliver du ofte bedt om at angive subnet og subnet mask.
                            Vi bruger udelukkende DHCP til at tildele IP-adresser på vores forbindelser.
                            Og du skal derfor sætte routeren op til &ldquo;automatisk&rdquo;, &ldquo;dynamisk IP&rdquo;, &ldquo;DHCP&rdquo; eller tilsvarende i forbindelsestypen.
                            Herefter skal du følge <Link to={'/hjaelp/udstyr/vlan-tagging'}>vores guide til VLAN-tagging</Link>.
                        </p>
                        <p>
                            Hvis du betaler for en fast IP, sørger vi for, at du altid vil få den samme IP-adresse.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad er en subnet mask?</h2>
                        <p>
                            En subnet mask opdeler et IP-netværk i mindre dele, kaldet subnets.
                            Den definerer, hvilke dele af en IP-adresse, der repræsenterer netværket, og hvilke der repræsenterer værten (enheden) på det netværk.
                        </p>
                        <p>
                            For IPv4 er en subnet mask en 32-bit adresse.
                            Eksempelvis <code className={'inline-code'}>255.255.255.0</code> som ofte bruges i hjemmenetværk.
                            I IPv6 er subnet masks længere, typisk 128-bit.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad er en subnet calculator?</h2>
                        <p>
                            En subnet calculator er et værktøj, som netværksadministratorer bruger til at planlægge og optimere netværk.
                            Den hjælper med at beregne antallet af subnets, finde brugbare IP-adresser og definere subnet mask for hver del af netværket.
                            Den gør det også lettere at allokere ressourcer og sikre, at netværket fungerer effektivt.
                        </p>
                        <ul className="list list--bullet">
                            <p>
                                En subnet calculator kan blandt andet:
                            </p>
                            <li>
                                Beregne hvor mange subnets, der kan oprettes fra en given subnet mask.
                            </li>
                            <li>
                                Vise antallet af brugbare IP-adresser i hvert subnet.
                            </li>
                            <li>
                                Angive start- og slutadresser for hvert subnet.
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad er en privat IP-adresse?</h2>
                        <p>
                            Vores kunder får som udgangspunkt tildelt en privat IP-adresse, hvilket også kaldes for Carrier-Grade NAT (CGNAT).
                            I stedet for at give hver kunde en unik offentlig IP-adresse, deler flere kunder én offentlig IP ved hjælp af private IP-adresser internt i vores netværk.
                            Du kan læse mere om <Link to={'/hjaelp/internet-og-wifi/ip-adresse'}>IP-adresser i denne artikel</Link>.
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "internet-og-wifi",
                        "article": "offline",
                        "name": "Mit internet virker ikke"
                    },
                    {
                        "category": "udstyr",
                        "article": "ip-adresse",
                        "name": "IP-adresse"
                    },
                    {
                        "category": "udstyr",
                        "article": "vlan-tagging",
                        "name": "Guide til VLAN-tagging"
                    },
                    {
                        "category": "udstyr",
                        "article": "kan-jeg-bruge-mit-eget-udstyr",
                        "name": "Kan jeg bruge mit eget udstyr?"
                    }
                ]}
            />
        </>
    )
}